/* Change this file to get your personal Portfolio */

// Website related settings
const settings = {
  isSplash: false,
};

//SEO Related settings
const seo = {
  title: "Zachary's Portfolio",
  description:
    "Actuarial consultant with experience across valuations, experience analysis, AASB 17 reporting, and Python-based actuarial modelling.",
  og: {
    title: "Zachary Bushby Portfolio",
    type: "website",
    url: "https://zbushby.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Zachary Bushby",
  logo_name: "ZacharyBushby",
  nickname: "Hi I'm Zach!",
  subTitle:
    " Actuarial consultant at KPMG. Passionate about AI and emerging analytics applied to insurance.",
  resumeLink:
    "https://docs.google.com/document/d/19uQsQsoCwPdZaBDxLT2-k0keSVU-0Pdc/edit?usp=sharing&ouid=105209283351272894952&rtpof=true&sd=true",
  portfolio_repository: "https://github.com/zbushby/zbushby.github.io",
  githubProfile: "https://github.com/zbushby",
};

const socialMediaLinks = [
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/zachary-bushby/",
    fontAwesomeIcon: "fa-linkedin-in",
    backgroundColor: "#0077B5",
  },
  {
    name: "Gmail",
    link: "mailto:zachbush678@gmail.com",
    fontAwesomeIcon: "fa-google",
    backgroundColor: "#D14836",
  },
  {
    name: "Github",
    link: "https://www.github.com/zbushby/",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
];

const skills = {
  data: [
    {
      title: "Actuarial & Financial Risk",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Built and automated Python-based valuation models supporting AASB 17 statutory reporting",
        "⚡ Conducted experience investigations and financial reporting analysis using Python, Excel, and SQL",
        "⚡ Valuations, experience analysis, and regulatory reporting (FCRs, AVRs)",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "logos:python",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "R",
          fontAwesomeClassname: "logos:r-lang",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "SQL",
          fontAwesomeClassname: "vscode-icons:file-type-sql",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Excel",
          fontAwesomeClassname: "vscode-icons:file-type-excel",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "Data Science & AI",
      fileName: "FullStackImg",
      skills: [
        "⚡ Data manipulation and analysis with Pandas, Polars, and NumPy",
        "⚡ Data visualisation with Plotly, Dash, Matplotlib, and Seaborn",
        "⚡ AI-assisted development with Claude Code and GitHub Copilot; building agentic AI workflows",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "logos:git-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "NumPy",
          fontAwesomeClassname: "logos:numpy",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Plotly",
          fontAwesomeClassname: "simple-icons:plotly",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Selenium",
          fontAwesomeClassname: "simple-icons:selenium",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Claude",
          fontAwesomeClassname: "simple-icons:anthropic",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "OpenAI",
          fontAwesomeClassname: "simple-icons:openai",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [],
};

const degrees = {
  degrees: [],
};

const certifications = {
  certifications: [],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Education",
  description:
    "Actuarial consultant at KPMG, having interned and worked across actuarial consulting, financial risk, and data analytics. Pursuing Fellowship with all Part I exemptions and two Part II subjects complete. Passionate about applying AI and emerging analytics to complex insurance problems.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Consultant, Life Actuarial",
          company: "KPMG",
          company_url: "https://kpmg.com/au/en/home.html",
          logo_path: "KPMG.svg",
          duration: "Feb 2025 - Present",
          location: "Melbourne, Australia",
          description:
            "Built and automated Python-based valuation models supporting the Appointed Actuary with AASB 17 reporting. Automated model setups, checks, and billing workflows by migration to Python. Collaborated directly with clients to explain valuation movements and model outputs. Conducted experience investigations and financial reporting analysis.",
          color: "#000000",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Vacationer, Financial Risk Management",
          company: "KPMG",
          company_url:
            "https://kpmg.com/au/en/home/services/advisory/risk-consulting/financial-risk-management.html",
          logo_path: "KPMG.svg",
          duration: "Nov 2023 - Jan 2024",
          location: "Melbourne, Australia",
          description:
            "Conducted valuations of financial instruments including share-based payments using Excel, R, Bloomberg, and IRESS, supporting market risk assessments for clients.",
          color: "#000000",
        },
        {
          title: "Actuarial Intern, Private Health Insurance",
          company: "Finity Consulting",
          company_url: "https://finity.com.au/",
          logo_path: "Finity.png",
          duration: "Aug 2023 - Oct 2023",
          location: "Melbourne, Australia",
          description:
            "Analysed private health insurance datasets using R, Excel, and Selenium (web scraping), delivering insights on pricing trends and member behaviour. Gained exposure to health and general insurance methodologies.",
          color: "#ee3c26",
        },
        {
          title: "Risk Advisory Intern, Data and Analytics",
          company: "Deloitte",
          company_url: "https://www2.deloitte.com/au/en.html",
          logo_path: "deloitte.png",
          duration: "Jun 2023 - Jul 2023",
          location: "Melbourne, Australia",
          description:
            "Developed automated wage remediation solutions using T-SQL and R, addressing regulatory and compliance risks across large datasets.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "University Club Involvement",
      experiences: [
        {
          title: "President (2024)",
          company: "Monash Actuarial Student Society",
          company_url: "",
          logo_path: "MASS.png",
          duration: "Sep 2023 - Nov 2024",
          location: "Clayton, Australia",
          description: "",
          color: "#4285F4",
        },
        {
          title: "Treasurer",
          company: "Monash Judo Club",
          company_url: "",
          logo_path: "judoclub.jpeg",
          duration: "Feb 2023 - Feb 2024",
          location: "Clayton, Australia",
          description: "",
          color: "#D83B01",
        },
        {
          title: "Subcommittee",
          company: "Monash Actuarial Student Society",
          company_url: "",
          logo_path: "MASS.png",
          duration: "Jan 2023 - Sep 2023",
          location: "Clayton, Australia",
          description:
            "As a subcommittee member in the Monash Actuarial Student Society, I collaborated closely and supported directors from planning to executing engaging events, contributing to the growth of the society\u2019s presence within the actuarial community.",
          color: "#000000",
        },
      ],
    },
    {
      title: "Education",
      experiences: [
        {
          title: "Bachelor of Actuarial Science & Bachelor of Commerce",
          company: "Monash University",
          company_url: "",
          logo_path: "monash.png",
          duration: "Feb 2021 - Nov 2024",
          location: "Clayton, Australia",
          description:
            "Business Analytics major, Computer Science minor. All Part I actuarial exemptions, Actuarial Control Cycle and Data Science Principles.",
          color: "#000000",
        },
        {
          title: "High School",
          company: "John Monash Science School",
          company_url: "",
          logo_path: "johnmonash.jpeg",
          duration: "Jan 2018 - Dec 2020",
          location: "Clayton, Australia",
          description:
            "House Captain. National physics tournament champions; selected to represent Australia (IYPT 2020). VCE Top Talks presenter (one of four selected statewide).",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Achievements",
      experiences: [
        {
          title: "Top Talks 2021",
          company: "VCE Season of Excellence",
          company_url: "",
          logo_path: "VCAA.svg",
          duration: "Feb 2021",
          location: "",
          description:
            "VCE Season of Excellence, Top Talks Presenter. Only 4 speakers were selected from the Victorian Extended Investigation Cohort, presenting my research project on a hypothetical spring-tuned mass damper supported by mathematical simulations and models.",
          color: "#000000",
        },
        {
          title: "International Young Physicist Tournament",
          company: "IYPT",
          company_url: "",
          logo_path: "IYPT.png",
          duration: "Nov 2020",
          location: "",
          description:
            "Part of the national team to compete in the International Young Physicist Tournament in Romania. Unfortunately, our research could not be presented as the pandemic restricted all international travel.",
          color: "#1f7a3a",
        },
        {
          title: "John Monash Gold Diploma",
          company: "John Monash Science School",
          company_url: "",
          logo_path: "JMSS.svg",
          duration: "Nov 2020",
          location: "",
          description:
            "The JMSS Gold Diploma is awarded to students who have made an outstanding contribution to the school during their high school career.",
          color: "#ee3c26",
        },
        {
          title: "CERN Beamlines shortlist Top 23",
          company: "CERN",
          company_url: "",
          logo_path: "CERN.png",
          duration: "Jan 2020",
          location: "",
          description:
            "International physics competition for high school students organised by CERN, the European Organization for Nuclear Research, in Geneva, Switzerland and DESY, Hamburg, Germany. 198 research proposals from 47 countries.",
          color: "#0033a0",
        },
        {
          title: "Australian Young Physicist Tournament",
          company: "AYPT",
          company_url: "",
          logo_path: "IYPT.png",
          duration: "Jan 2019",
          location: "",
          description:
            "Competed in the national young physicist tournament; our team of 3 competed in Brisbane against schools from various states. We achieved high distinction and came first in the tournament.",
          color: "#1f7a3a",
        },
        {
          title: "Thailand International Science Fair",
          company: "Mahidol Wittayanusorn",
          company_url: "",
          logo_path: "TISF.png",
          duration: "Jan 2019",
          location: "",
          description:
            "Selected to present our research project with 5 of my peers at the Thailand International Science Fair.",
          color: "#ee3c26",
        },
        {
          title: "Scout Medallion",
          company: "Scouts Australia",
          company_url: "",
          logo_path: "Scouts.png",
          duration: "Nov 2018",
          location: "",
          description:
            '"The Scout Medallion Award is the highest award you can earn in the Scout Section. It is considered the pinnacle of your Scouting and is a milestone in your Scouting life." — Scouts Australia',
          color: "#006a4e",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description: "",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "photo_zach.png",
    description:
      " Send me a message! I would love to get in touch! Email: zachbush678@gmail.com",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "",
    subtitle: "",
    locality: "",
    country: "",
    region: "",
    postalCode: "",
    streetAddress: "",
    avatar_image_path: "",
    location_map_link: "",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
